/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AccountRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let person = this.modelFor('people.person').person;
    return hash({
      person,
      account: this.store.findRecord('finance/account', params.account_id),
      transactions: this.store.query('finance/transaction', {
        accountId: params.account_id,
        include: 'lineItems,accounts,childTransactions',
      }),
    });
  }
}
